export type AppItem = {
    slug: string;
    name: string;
    description: string;
};

export type AppCategory = {
    id: string;
    name: string;
    /** CSS gradient, used for the app icon swatch */
    gradient: string;
    apps: Array<AppItem>;
};

/* Source: I-OS Products Breakdown, 5 categories, 24 apps */
export const appCategories: Array<AppCategory> = [
    {
        id: "intelligence",
        name: "Intelligence",
        gradient: "linear-gradient(135deg,#6647F0,#4C56F2)",
        apps: [
            {
                slug: "ai-agent",
                name: "AI Agent",
                description: "Agents across the whole OS that read your data and take action, not just Q&A.",
            },
            {
                slug: "analytics",
                name: "Analytics",
                description: "Unified dashboards, reports and attribution across every app, fed by built-in connectors (Meta, Google, Amazon, Flipkart).",
            },
            {
                slug: "connector",
                name: "Connector",
                description:
                    "Connect any external data source or business system, ad platforms, marketplaces, ERP, accounting, payments, shipping, so your whole stack flows into one OS.",
            },
        ],
    },
    {
        id: "demand-and-brand",
        name: "Demand & Brand",
        gradient: "linear-gradient(135deg,#F26B6B,#E2364A)",
        apps: [
            {slug: "website", name: "Website", description: "Build and run any kind of brand-owned website or landing page."},
            {slug: "content", name: "Content", description: "Write, manage and publish blogs, pages and media."},
            {
                slug: "campaigns",
                name: "Campaigns",
                description: "Outbound multi-channel campaigns and automation across WhatsApp, email and SMS.",
            },
            {slug: "chat", name: "Chat", description: "Live two-way conversations with people across different platforms."},
            {slug: "events", name: "Events", description: "Manage events end-to-end, from registration and ticketing to feedback."},
        ],
    },
    {
        id: "sales-and-distribution",
        name: "Sales & Distribution",
        gradient: "linear-gradient(135deg,#00A2ED,#1F40CB)",
        apps: [
            {
                slug: "crm",
                name: "CRM",
                description:
                    "Full customer journey across the enterprise, leads, pipeline, accounts, with built-in calling, scheduling and feedback.",
            },
            {slug: "sales", name: "Sales", description: "Quotations, orders and the sale workflow from enquiry to close."},
            {slug: "online-store", name: "Online Store", description: "Storefront for D2C and B2B, catalog, cart and checkout."},
            {
                slug: "dealer-network",
                name: "Dealer Network",
                description: "Manage dealers, distributors and the partners who sell for you, panels, targets and performance.",
            },
            {
                slug: "field-sales",
                name: "Field Sales",
                description: "Field-sales execution, beat planning (PJP), GPS check-ins and on-ground activity.",
            },
            {slug: "sales-incentives", name: "Sales Incentives", description: "Leaderboards, contests and rewards for field and channel teams."},
        ],
    },
    {
        id: "fulfilment-and-service",
        name: "Fulfilment & Service",
        gradient: "linear-gradient(135deg,#0FB28F,#0A8F70)",
        apps: [
            {slug: "inventory", name: "Inventory", description: "Manage stock, warehouses and product availability."},
            {slug: "invoicing", name: "Invoicing", description: "Generate invoices, manage billing and track payments."},
            {slug: "field-service", name: "Field Service", description: "Schedule and dispatch technicians for on-site service and repairs."},
            {slug: "warranty", name: "Warranty", description: "Register products and manage warranty claims."},
            {slug: "helpdesk", name: "Helpdesk", description: "Multi-channel customer support tickets and resolution tracking."},
        ],
    },
    {
        id: "people-and-operations",
        name: "People & Operations",
        gradient: "linear-gradient(135deg,#FFB100,#FF7A00)",
        apps: [
            {slug: "attendance", name: "Attendance", description: "Track employee attendance, check-in/out, shifts and leave."},
            {slug: "recruitment", name: "Recruitment", description: "Recruit, hire and onboard new people."},
            {slug: "learning", name: "Learning", description: "Learning management, courses, training and certification."},
            {slug: "approvals", name: "Approvals", description: "Route and capture sign-offs from teams and clients."},
            {slug: "documents", name: "Documents", description: "Central file storage and document management."},
        ],
    },
];
